export var ADD_NOTIFICATIONS_DATA = 'ADD_NOTIFICATIONS_DATA';
export var addNotificationsData = function (notifications) { return function (dispatch) {
    return dispatch({
        type: ADD_NOTIFICATIONS_DATA,
        payload: { notifications: notifications },
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/notifications.actions.ts
// module id = 622
// module chunks = 81